import { State, getCheckout } from "./checkout";
import { ICartItem } from "../../../../../models";

const getCart = (state: State): ICartItem[] => getCheckout(state).cart?.content || [];

const getCartItemByBundleId = (state: State, bundleId: string) =>
    getCart(state).find((item) => item.bundleId === bundleId);

export const isFlexLease = (state: State, bundleId: string) => {
    const cartItem = getCartItemByBundleId(state, bundleId);
    return (cartItem?.price.monthly || 0) > 0 && (cartItem?.price.upfront || 0) > 0;
};
